import { ProgressProps as ChakraProgressProps, Progress as ChakraProgress } from '@chakra-ui/react';
import { ComponentStyleConfig } from '@chakra-ui/theme';
import { primaryThemeGradient } from 'constants/theme';

const ProgressStyles: ComponentStyleConfig = {
  baseStyle: {
    track: {
      borderRadius: 24,
      background: 'base2Colour.500',
    },
    filledTrack: {
      bg: primaryThemeGradient,
    },
  },
  sizes: {
    sm: {
      track: {
        h: 1,
      },
    },
  },
};

const Progress = ({ size = 'sm', ...props }: ChakraProgressProps) => <ChakraProgress size={size} {...props} />;

export { Progress, ProgressStyles };
